// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__4jC-p","inner":"Footer_inner__K7yHn"};